import { useQuery } from '@tanstack/react-query';

import { listQueryOptions } from '@/lib/query-client';

import { redFlagsService } from '../services';
import type { RedFlagListParams } from '../types';

import { redFlagsKeys } from './useRedFlags';

export function useClientRedFlags(clientId: string | undefined, params: RedFlagListParams = {}) {
  return useQuery({
    queryKey: redFlagsKeys.operation('client', { clientId: clientId ?? '', ...params }),
    queryFn: () => {
      if (!clientId) throw new Error('missing clientId');
      return redFlagsService.listClientFlags(clientId, params);
    },
    enabled: Boolean(clientId),
    ...listQueryOptions,
  });
}
